import { ofType } from "redux-observable";
import { combineLatest, EMPTY, from, of } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { IdBuilding } from "../../../constants/IdBuilding";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { selectSelectedDiscountEvent } from "../../../selectors/selectDiscountEvent";
import { selectBuildingsInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { selectExpansionInfo } from "../../../selectors/selectExpansionInfo";
import { selectAutoSelectedExpansionId, selectExpansionXYFromIdGlobal, } from "../../../selectors/selectUnlockableExpansionIds";
import { utilBuildings } from "../../../utils/utilBuildings";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionActionButtonFocusBuilding } from "../../hud-action-button/actionHudActionButton";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionBuildingsSelect, actionBuildingsShowBouncingArrow, } from "../../player-base/buildings/actionBuildings";
import { actionExpansionsSelect } from "../../player-base/expansions/actionExpansions";
import { actionShopOpenOffer } from "../../shop/actionShop";
import { TypeActionShowMe } from "../../show-me/actionShowMe";
import { createPathSelectBuildingInBuildMenu } from "../../show-me/path/createPathSelectBuildingInBuildMenu";
import { actionViewportCenterOn } from "../../viewport/actionViewport";
import { TypeActionDiscountEvent } from "../actionDiscountEvent";
export var epicDiscountEventShowMe = function (action$, state$, deps) {
    var showMeAction$ = action$.pipe(ofType(TypeActionDiscountEvent.ShowMe));
    var viewport$ = deps.inStoreDependencies.viewportChanged$.pipe(filter(function (viewport) { return !!viewport; }), take(1));
    return combineLatest(showMeAction$, viewport$).pipe(switchMap(function (_a) {
        var action = _a[0], viewport = _a[1];
        var state = state$.value;
        var discountEvent = selectSelectedDiscountEvent(state);
        switch (discountEvent.balancing.type) {
            case EventType.ExpansionDiscount:
                return showMeExpansionDiscount(state, viewport);
            case EventType.FancyHouseDiscount:
                return showMeBuildingDiscount(IdBuilding.FancyHouse, state$, deps, viewport);
            case EventType.FertileAcreDiscount:
                return showMeBuildingDiscount(IdBuilding.FertileAcre, state$, deps, viewport);
            case EventType.OutskirtDiscount:
                return of(actionActionButtonFocusBuilding(IdOutskirtBuildings.ExternalBarn));
            case EventType.PrimeTime:
                return of(actionShopOpenOffer(discountEvent.balancing.webTargetId));
            default:
                return EMPTY;
        }
    }));
};
var showMeExpansionDiscount = function (state, viewport) {
    var expansionId = selectAutoSelectedExpansionId(state);
    if (expansionId == undefined) {
        return EMPTY;
    }
    var expansions = selectExpansionInfo(state).expansions;
    var expansion = expansions[expansionId - 1];
    var pos = selectExpansionXYFromIdGlobal(state, expansionId, viewport);
    return from([
        actionViewportCenterOn(pos, false),
        actionExpansionsSelect(expansionId, expansion),
    ]);
};
var highestLevelBuildingReducer = function (highestLevelBuilding, currentBuilding) {
    return highestLevelBuilding === undefined ||
        highestLevelBuilding.proto.stage < currentBuilding.proto.stage
        ? currentBuilding
        : highestLevelBuilding;
};
var showMeBuildingDiscount = function (buildingId, state$, deps, viewport) {
    var state = state$.value;
    var buildingInfo = selectBuildingsInfoByTypeId(state, buildingId)
        .filter(utilBuildings.isProducing)
        .reduce(highestLevelBuildingReducer, undefined);
    if (buildingInfo !== undefined) {
        var pos = utilBuildings.getCenterPositionOnScreen(buildingInfo, viewport);
        return from([
            actionModalClose(IdModal.DiscountEvent),
            actionViewportCenterOn(pos, false),
            actionBuildingsSelect(buildingInfo),
            actionBuildingsShowBouncingArrow(buildingInfo, true),
        ]);
    }
    return createPathSelectBuildingInBuildMenu(function () { return buildingId; })({ type: TypeActionShowMe.SelectBuildingInfoInBuildMenu }, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/epics/epicDiscountEventShowMe.ts
// module id = 1833
// module chunks = 3